import { isNotNull } from './is-not-null.js';

/**
 * Проверяет, является ли переданное значение объектом (в том числе и массивом)
 */
export function isObject(value: unknown): value is object {
  return typeof value === 'object' && isNotNull(value);
}
